<template style="background:black">
    <div class="flex flex-center q-pa-md" style="height: 100vh;">

        <q-dialog v-model="confirmPago" persistent>
            <q-card style="width:350px;">
                <q-card-section class="row items-center justify-center q-mt-md">
                    <q-avatar size="150px" font-size="150px" icon="mdi-check-circle" color="primary"
                        text-color="white" />
                    <div class="text-primary text-h4">Pago Exitoso</div>
                </q-card-section>
                <q-card-actions align="right">
                    <q-btn flat label="ACEPTAR" color="primary" @click="inicializarPago()" />
                </q-card-actions>
            </q-card>
        </q-dialog>

        <q-card class="q-pa-md " style="width: 600px;">
            <q-card-section>
                <div class="row justify-between text-bold">
                    <div class="text-h6" style="color: #1F3664;">Información de Pago</div>
                    <img src="../assets/kushki_CCslogo.png" alt="" height="auto" width="100" class="q-my-sm">
                </div>
                <q-separator />
                <q-stepper class="shadow-0" v-model="step" vertical color="primary" animated>
                    <q-step :name="1" title="Datos Generales" icon="mdi-account-edit" :done="step > 1">
                        <q-card class="shadow-0">
                            <q-card-section>
                                <q-form @submit="validarAddress" v-if="addressSelect">
                                    <div class="text-h6 row" style="color: #1F3664;">
                                        Información General
                                    </div>
                                    <q-select dense outlined v-model="info" :options="optionsDirecciones"
                                        label="Dirección" option-label="name" required
                                        :rules="[val => val && val.name.length > 0]">
                                        <template v-slot:option="scope">
                                            <q-item v-bind="scope.itemProps" v-on="scope.itemEvents">
                                                <q-item-section>
                                                    <q-item-label v-html="scope.opt.name" />
                                                    <q-item-label caption>
                                                        {{
                                                            scope.opt.address + ', ' +
                                                            scope.opt.city + ', ' +
                                                            scope.opt.region + ', ' +
                                                            scope.opt.country + ', ' +
                                                            scope.opt.zipCode + ', Tel ' +
                                                            scope.opt.phone }}</q-item-label>
                                                </q-item-section>
                                                <q-item-section side top>
                                                    <q-btn flat round color="primary" icon="mdi-pencil"
                                                        @click="editarDireccion(scope.opt)" />
                                                </q-item-section>
                                            </q-item>
                                        </template>

                                    </q-select>

                                    <div align="right">
                                        <q-btn @click="NuevaDireccion()" label="Nueva" />
                                        <q-btn color="primary" class="q-ml-md" type="submit" label="Continuar" />
                                    </div>
                                </q-form>

                                <q-form v-else @submit="validarGenerales">
                                    <div class="text-h6 row" style="color: #1F3664;">
                                        Información General
                                    </div>
                                    <q-input dense outlined v-model="info.name" label="Nombre" required
                                        :rules="[val => val && val.length > 0]" />
                                    <q-input dense outlined v-model="info.phone" label="Número de Teléfono"
                                        mask="(###) ### - ####" required :rules="[val => val && val.length > 0]" />
                                    <q-input dense outlined v-model="info.address" label="Dirección" required
                                        :rules="[val => val && val.length > 0]" />
                                    <q-input dense outlined v-model="info.city" label="Ciudad" required
                                        :rules="[val => val && val.length > 0]" />
                                    <q-input dense outlined v-model="info.region" label="Región" required
                                        :rules="[val => val && val.length > 0]" />
                                    <q-input dense outlined v-model="info.country" label="País" required
                                        :rules="[val => val && val.length > 0]" />
                                    <q-input dense outlined v-model="info.zipCode" label="Código Postal" required
                                        :rules="[val => val && val.length > 0]" />
                                    <div align="right">
                                        <q-btn label="Cerrar" @click="addressSelect = true" />
                                        <q-btn color="primary" class="q-ml-md" type="submit" label="Guardar"
                                            :loading="loadingPostDireccion" />
                                    </div>
                                </q-form>
                            </q-card-section>
                        </q-card>
                    </q-step>
                    <q-step :name="3" title="Seleccione su Tarjeta" icon="mdi-credit-card" :done="step > 3">
                        <q-card class="shadow-0">
                            <q-card-section>
                                <q-form v-if="!newCard" @submit="validarTarjeta">
                                    <div class="text-h6 row" style="color: #1F3664;">
                                        Seleccione su Tarjeta
                                    </div>
                                    <q-select dense outlined v-model="modelTarjeta" :options="optionsTarjetas"
                                        label="Tarjeta" option-label="tarjeta" required
                                        :rules="[val => val && val.tarjeta.length > 0]">
                                        <template v-slot:option="scope">
                                            <q-item v-bind="scope.itemProps" v-on="scope.itemEvents">
                                                <q-item-section>
                                                    <q-item-label v-html="scope.opt.nombretarjeta" />
                                                    <q-item-label caption>{{ scope.opt.tarjeta }}</q-item-label>
                                                </q-item-section>
                                            </q-item>
                                        </template>
                                    </q-select>
                                    <div class="text-right">
                                        <q-btn @click="newCard = true" label="Nueva Tarjeta" />
                                        <q-btn type="submit" color="primary" label="Continuar" class="q-ml-sm" />
                                    </div>
                                </q-form>

                                <q-form v-else @submit="procesarSubscription" class="q-col-gutter-md">
                                    <div class="text-h6 row" style="color: #1F3664;">
                                        Datos de Contacto
                                    </div>
                                    <q-input dense outlined v-model="form.email" label="Email" required />
                                    <q-input dense outlined v-model="form.phoneNumber" label="Número de Teléfono"
                                        mask="(###) ### - ####" required />
                                    <div class="text-h6 row" style="color: #1F3664;">
                                        Datos de la Tarjeta
                                    </div>
                                    <q-input dense outlined v-model="form.name" label="Nombre" required />

                                    <q-input dense outlined v-model="form.number" label="Número de tarjeta"
                                        mask="#### #### #### ####" required />
                                    <div class="row q-col-gutter-md">
                                        <q-select dense outlined v-model="form.expiryYear" :options="years" label="Año"
                                            class="col" required />
                                        <q-select dense outlined v-model="form.expiryMonth" :options="filteredMonths"
                                            label="Mes" class="col" required />

                                        <q-input dense outlined v-model="form.cvv" label="CVC" mask="####" class="col"
                                            required type="password" />
                                    </div>
                                    <div class="text-right">
                                        <q-btn @click="newCard = false" label="cerrar" />
                                        <q-btn label="REGISTRAR TARJETA" type="submit" size="md" color="primary"
                                            class=" q-ml-md" :loading="loading" />
                                    </div>
                                </q-form>
                            </q-card-section>
                        </q-card>

                    </q-step>

                    <q-step :name="4" title="Confirme su Pago" icon="mdi-credit-card">
                        <q-form @submit="requestDeviceToken">
                            <div class="row">
                                <div class="col q-pr-md">
                                    <div class="text-subtitle2 row justify-between"
                                        style="font-size: 18px; color: #1F3664;">
                                        Datos Generales
                                        <q-btn size="sm" round color="primary" icon="mdi-pencil"
                                            @click="editarDireccionFinal()" />
                                    </div>
                                    <a>{{ info.name }}</a><br>
                                    <a>{{ info.address }}</a><br>
                                    <a>{{ info.city }}</a><br>
                                    <a>{{ info.region }}</a><br>
                                    <a>{{ info.country }}</a><br>
                                    <a>{{ info.phone }}</a><br>
                                    <a>{{ info.zipCode }}</a><br>
                                </div>
                                <q-separator vertical />

                                <div class="col q-pl-md">
                                    <div class="text-subtitle2 row justify-between"
                                        style="font-size: 18px;color: #1F3664;">Forma de
                                        Pago
                                        <q-btn size="sm" round color="primary" icon="mdi-pencil" @click="step = 3" />
                                    </div>

                                    <a>{{ modelTarjeta.nombretarjeta }}</a><br>
                                    <a>{{ modelTarjeta.tarjeta }}</a><br>
                                </div>

                                <div class="col-12 text-center q-mt-lg">
                                    <q-btn :label="montoPagar" type="submit" size="md" color="primary"
                                        class="full-width" :loading="loadingDos" />
                                </div>
                            </div>
                        </q-form>
                    </q-step>

                </q-stepper>
                <div class="text-center">

                    <img src="../assets/kushki_CCslogo.png" alt="" width="100" class="q-mt-md">
                </div>

            </q-card-section>
        </q-card>
    </div>
</template>

<script>
import { Kushki } from '@kushki/js';
import axios from "axios";
import CryptoJS from "crypto-js";

export default {
    data() {
        return {
            kushki: null,
            form: {
                name: "",
                number: "",
                cvv: "",
                expiryMonth: null,
                expiryYear: null,
                email: '',
                phoneNumber: '',
                sistema: '',
                id_usuario: ''
            },

            months: Array.from({ length: 12 }, (_, i) => ({
                label: (i + 1).toString().padStart(2, "0"),
                value: (i + 1).toString().padStart(2, "0"),
            })),

            years: Array.from({ length: 10 }, (_, i) => ({
                label: (new Date().getFullYear() + i).toString(),
                value: (new Date().getFullYear() + i).toString(),
            })),
            loading: false,
            errorMessage: "",

            monto: 0,
            montoFormated: '',
            sistema: '',
            id_usuario: '',
            optionsTarjetas: [],
            modelTarjeta: { tarjeta: '' },
            altaTarjeta: false,
            loadingDos: false,
            id_pedido: '',
            info: {
                _id: '',
                name: '',
                phone: '',
                address: '',
                city: '',
                region: '',
                country: '',
                zipCode: ''
            },
            confirmPago: false,
            step: 1,
            optionsDirecciones: [],
            modelDireccion: {
                address: ''
            },
            addressSelect: true,
            loadingPostDireccion: false,

            newCard: false

            // 4456529165328302
            // http://localhost:8080/?monto=10&id_usuario=672e50d1062c99d864dfec7d&sistema=erp_iia040805dz4&id_pedido=67cf3f84896b723e6c91c7fa
        };
    },
    mounted() {
        this.kushki = new Kushki({
            merchantId: "80c5434f571746c199e3d53e16d542ba",
            // merchantId: "8a57d80ca61147b287fea71395cbf958",
            inTestEnvironment: false,
        });

        const CryptoJS = require('crypto-js');
        const secretKey = 'id_key_25188289830176';

        // EJEMPLO PARA ENCRIPTAR
        // const params = "monto=10.5&id_usuario=68dd515cf06a3176cb778af3&sistema=OACC910531MCA&id_pedido=1";
        // const encrypted = CryptoJS.AES.encrypt(params, secretKey).toString();
        // const url = `https://cobroecomerce.contago.com.mx/?params=${encodeURIComponent(encrypted)}`;
        // console.log(url);

        const encryptedParams = this.getUrlParameter('params');
        if (encryptedParams) {
            const decrypted = this.decryptParams(encryptedParams);
            console.log('Decrypted string:', decrypted);

            const params = this.parseParams(decrypted);
            console.log('Parsed params:', params);

            this.monto = parseFloat(params.monto);
            this.montoFormated = this.FormatCurrency(this.monto);
            this.id_usuario = params.id_usuario;
            this.sistema = params.sistema;
            this.id_pedido = params.id_pedido;
        }
        this.GetAddressDetails();
        this.GetTarjetas();
        console.log("Monto:", this.montoFormated, "Usuario:", this.id_usuario, "sistema", this.sistema, 'pedido', this.id_pedido);
    },
    computed: {
        montoPagar() {
            return 'Pagar ' + this.montoFormated + ' MXN'
        },
        filteredMonths() {
            const currentYear = new Date().getFullYear()
            const currentMonth = new Date().getMonth() + 1 // Los meses en JS van de 0 a 11
            const selectedYear = parseInt(this.form.expiryYear?.value ?? 0)
            console.log(currentYear)
            console.log(selectedYear)
            return this.months.filter(month => {
                const monthValue = parseInt(month.value)
                // Si el año seleccionado es el actual, mostrar solo meses >= mes actual
                if (selectedYear === currentYear) {
                    return monthValue >= currentMonth
                }
                // Si es un año futuro, mostrar todos los meses
                return true
            })
        }
    },
    created() {
        this.id_usuario = this.$route.query.id_usuario;
        this.sistema = this.$route.query.sistema;


    },
    methods: {
        getUrlParameter(name) {
            const regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
            const results = regex.exec(window.location.href);
            return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
        },
        decryptParams(encryptedParams) {
            const secretKey = 'id_key_25188289830176';
            const bytes = CryptoJS.AES.decrypt(encryptedParams, secretKey);
            return bytes.toString(CryptoJS.enc.Utf8);
        },
        parseParams(paramString) {
            const params = {};
            const pairs = paramString.split('&');
            pairs.forEach(pair => {
                const [key, value] = pair.split('=');
                params[key] = value;
            });
            return params;
        },
        procesarSubscription() {
            if (!this.form.cvv || (this.form.cvv.length !== 3 && this.form.cvv.length !== 4)) {
                this.$q.notify({
                    type: 'warning',
                    progress: true,
                    color: 'orange',
                    position: 'top-right',
                    message: 'El CVV debe tener 3 o 4 dígitos.'
                })
                return
            }
            this.loading = true;
            let objeto = {

            }
            this.kushki.requestSubscriptionToken({
                amount: this.monto,
                currency: "MXN",
                card: {
                    name: this.form.name,
                    number: this.form.number.replace(/\s/g, ""),
                    cvc: this.form.cvv,
                    expiryMonth: this.form.expiryMonth?.value,
                    expiryYear: this.form.expiryYear?.value.slice(-2),
                }
            }, async (response) => {
                console.log('ERROR', response);

                if (response.token) {
                    // ¿Requiere 3DS?
                    if (response.security?.authRequired) {
                        this.kushki.requestValidate3DS({
                            secureId: response.secureId,
                            security: response.security
                        }, async (res) => {
                            console.log("Resultado 3DS:", res)
                            if (!res.code) {
                                // 3DS exitoso
                                let objeto = {
                                    documentNumber: "XAXX02010000",
                                    documentType: "RFC",
                                    email: this.form.email,
                                    firstName: this.form.name,
                                    id_usuario: this.id_usuario,
                                    lastName: this.form.name,
                                    phoneNumber: '+52' + this.form.phoneNumber.replace(/[()\s-]/g, ''),
                                    sistema: this.sistema,
                                    tarjeta: this.form.number.replace(/\s/g, ""),
                                    token: response.token
                                };
                                console.log(objeto)
                                await this.AltaTarjetaKushki(objeto)
                            } else {
                                this.$q.notify({ type: 'negative', progress: true, position: 'top-right', message: 'Error en validación 3DS: ' + res.message })
                            }
                            this.loading = false;
                        });
                    } else {
                        // No requiere 3DS
                        let objeto = {
                            documentNumber: "XAXX02010000",
                            documentType: "RFC",
                            email: this.form.email,
                            firstName: this.form.name,
                            id_usuario: this.id_usuario,
                            lastName: this.form.name,
                            phoneNumber: '+52' + this.form.phoneNumber.replace(/[()\s-]/g, ''),
                            sistema: this.sistema,
                            tarjeta: this.form.number.replace(/\s/g, ""),
                            token: response.token
                        };
                        console.log(objeto)

                        await this.AltaTarjetaKushki(objeto)
                        this.loading = false;
                    }
                } else {
                    this.$q.notify({ type: 'negative', progress: true, position: 'top-right', message: response.message })
                    this.loading = false;
                }
            });
        },

        async requestDeviceToken() {

            this.loadingDos = true;

            // this.kushki.requestDeviceToken({
            //     amount: {
            //         currency: "MXN",
            //         subtotalIva: 0,
            //         iva: 0,
            //         subtotalIva0: this.monto,
            //     },
            //     currency: "MXN",
            //     subscriptionId: this.modelTarjeta.cardToken
            // }, async (response) => {
            //     console.log(response);

            //     if (response.token) {
            //         console.log(response);
            let objetoPago = {
                sistema: this.sistema,
                id_tarjeta: this.modelTarjeta._id,
                monto: this.monto,
                id_usuario: this.id_usuario,
                url: 'contago.com.mx',
                id_pedido: this.id_pedido,
                id_direccion: this.info._id
            }

            await this.GenerarCobro(objetoPago)
            this.loadingDos = false;

            //     } else {
            //         console.error('Error: ', response.error, 'Code: ', response.code, 'Message: ', response.message);
            //         this.loadingDos = false;

            //     }
            // });
        },

        async AltaTarjetaKushki(object) {
            console.log(object)
            try {
                let response = await axios.post('Pasarela/AltaTarjetaKushkiP', object);
                console.log(response)
                switch (response.data.edopet) {
                    case '-3':
                        this.$q.notify({ type: 'negative', progress: true, position: 'top-right', message: 'Tarjeta ya registrada' })
                        break;
                    case '-2':
                        this.$q.notify({ type: 'negative', progress: true, position: 'top-right', message: response.data.message })
                        break;
                    case '-1':
                        this.$q.notify({ type: 'negative', progress: true, position: 'top-right', message: 'Error al guardar su información, intentelo de nuevo.' })
                        break;
                    case '0':
                        this.$q.notify({ type: 'positive', progress: true, position: 'top-right', message: 'Nueva Tarjeta registrada exitosamente.' })
                        this.trueSaveCard();
                        this.GetTarjetas();
                        break;
                }
            } catch (error) {
                console.log(error)
            }
        },

        async GenerarCobro(object) {
            console.log(object)
            try {
                let response = await axios.post('Pasarela/CobroPasarelaKushkiP/', object);
                console.log(response)
                // switch (response.data.edopet) {
                //     case '0':
                //         this.$q.notify({ type: 'positive', progress: true, position: 'top-right', message: 'Pago Exitoso.' })
                //         // this.$router.push({ name: 'PagoCorrecto' });
                //         // this.$store.state.mensageStore = "Correcto"

                //         setTimeout(() => {
                //             this.$router.push('PagoCorrecto').then(() => {
                //                  window.location.reload();
                //             });
                //         }, 4000);

                //         // this.confirmPago = true
                //         break;
                //     case '-1':
                //         this.$q.notify({ type: 'negative', progress: true, position: 'top-right', message: response.data.respuesta })
                //         this.$store.state.mensageStore = response.data.respuesta
                //         // this.$router.push({ name: 'PagoRechazado' });
                //         setTimeout(() => {
                //             this.$router.push('PagoRechazado').then(() => {
                //                 window.location.reload();
                //             });
                //         }, 4000);
                //         break;
                // }

                switch (response.data.edopet) {
                    case '0':
                        this.$q.notify({
                            type: 'positive',
                            progress: true,
                            position: 'top-right',
                            message: 'Pago Exitoso.'
                        })

                        this.$router.push({ name: 'PagoCorrecto' }).then(() => {
                            setTimeout(() => {
                                window.location.reload()
                            }, 5000)
                        })
                        break

                    case '-1':
                        this.$q.notify({
                            type: 'negative',
                            progress: true,
                            position: 'top-right',
                            message: response.data.respuesta
                        })

                        this.$store.state.mensageStore = response.data.respuesta

                        this.$router.push({ name: 'PagoRechazado' }).then(() => {
                            setTimeout(() => {
                                window.location.reload()
                            }, 5000)
                        })
                        break
                }
            } catch (error) {
                console.log(error)
            }
        },

        async GetTarjetas() {
            let object = {
                id_usuario: this.id_usuario,
                sistema: this.sistema
            }
            // console.log(object)
            try {
                let response = await axios.post('Pasarela/GetTarjetas', object);
                console.log(response)
                this.optionsTarjetas = response.data.lista
            } catch (error) {
                console.log(error)
            }
        },

        async GetAddressDetails() {
            let object = {
                id_usuario: this.id_usuario,
                sistema: this.sistema
            }
            // console.log(object)
            try {
                let response = await axios.post('Pasarela/GetAddressDetails', object);
                console.log(response)
                this.optionsDirecciones = response.data
            } catch (error) {
                console.log(error)
            }
        },

        FormatCurrency(value) {
            return value.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
        },

        inicializarPago() {
            location.reload();
        },

        async validarGenerales() {
            if (this.info.name == '') {
                this.$q.notify({ type: 'warning', progress: true, color: 'orange', position: 'top-right', message: `Indique su nombre completo.` })
                return
            }
            if (this.info.phone == '') {
                this.$q.notify({ type: 'warning', progress: true, color: 'orange', position: 'top-right', message: `Indique un número teléfonico.` })
                return
            }
            if (this.info.address == '') {
                this.$q.notify({ type: 'warning', progress: true, color: 'orange', position: 'top-right', message: `Indique un dirección.` })
                return
            }
            if (this.info.city == '') {
                this.$q.notify({ type: 'warning', progress: true, color: 'orange', position: 'top-right', message: `Indique la su ciudad.` })
                return
            }
            if (this.info.region == '') {
                this.$q.notify({ type: 'warning', progress: true, color: 'orange', position: 'top-right', message: `Indique la región de donde se encuntra.` })
                return
            }
            if (this.info.country == '') {
                this.$q.notify({ type: 'warning', progress: true, color: 'orange', position: 'top-right', message: `Indique el país.` })
                return
            }
            if (this.info.zipCode == '') {
                this.$q.notify({ type: 'warning', progress: true, color: 'orange', position: 'top-right', message: `Indique su Código Postal.` })
                return
            }

            this.info.sistema = this.sistema
            this.info.id_usuario = this.id_usuario
            this.loadingPostDireccion = true
            try {
                let respuesta = null
                if (this.info._id == '') {
                    respuesta = await axios.post('Pasarela/PostAddress/', this.info);
                } else {
                    respuesta = await axios.post('Pasarela/PutAddress/', this.info);
                }
                console.log(respuesta)
                this.loadingPostDireccion = false
                this.$q.notify({ type: 'positive', progress: true, position: 'top-right', message: 'La dirección se ha guardado exitosamente.' })
                this.trueAddressSave()
            } catch (error) {
                this.loadingPostDireccion = false
                console.log(error)
            }
        },

        editarDireccion(item) {
            this.info = item
            this.addressSelect = false
        },

        editarDireccionFinal() {
            this.addressSelect = false
            this.step = 1
        },

        validarAddress() {
            this.step = 3
        },

        validarTarjeta() {
            this.step = 4
        },

        async trueSaveCard() {
            this.form = {
                _id: '',
                name: "",
                number: "",
                cvv: "",
                expiryMonth: null,
                expiryYear: null,
                email: '',
                phoneNumber: '',
            }
            this.newCard = false
        },

        NuevaDireccion() {
            this.info = {
                _id: '',
                name: '',
                phone: '',
                address: '',
                city: '',
                region: '',
                country: '',
                zipCode: '',
                sistema: '',
                id_usuario: ''
            }
            this.addressSelect = false
        },

        async trueAddressSave() {
            this.info = {
                _id: '',
                name: '',
                phone: '',
                address: '',
                city: '',
                region: '',
                country: '',
                zipCode: '',
                sistema: '',
                id_usuario: ''
            }
            await this.GetAddressDetails()
            this.addressSelect = true
        }
    },
};
</script>

<style>
.full-width {
    width: 100%;
}

body {
    background-color: azure;
}
</style>